<app-breadcrumbs></app-breadcrumbs>
<div id="container">
  <div class="search-section" [cfaLoading]="isLoading">
    <mat-form-field id="store-number-field" appearance="outline" [color]="!isStoreNumberValid ? 'warn': 'primary'">
      <mat-label>Store Number</mat-label>
      <input matInput  type="string" maxlength="5" minLength="5"
        [(ngModel)]="storeNumberInput"
        (ngModelChange)="onStoreNumberChange($event)"
        [disabled]="searchDisabled"
        autofocus/>
    </mat-form-field>
    <mat-form-field id="serial-number-field" appearance="outline" [color]="!isSerialNumberValid ? 'warn': 'primary'">
      <mat-label>Serial Number</mat-label>
      <input matInput  type="string" maxlength="16" minLength="16"
        [(ngModel)]="serialNumberInput"
        (ngModelChange)="onSerialNumberChange($event)"
        [disabled]="searchDisabled"
        autofocus/>
    </mat-form-field>
    <mat-form-field id="adom-field" appearance="outline" [color]="!isAdomValid ? 'warn': 'primary'">
      <mat-label>System</mat-label>
      <mat-select [panelWidth]="null" (selectionChange)="selectAdom($event.value)" [disabled]="searchDisabled">
        @for (adom of availableAdoms; track adom) {
          <mat-option [value]="adom.system_tag + '$' + adom.adom"><strong>{{adom.system_tag}}</strong>&nbsp;&nbsp;&nbsp;&nbsp;Adom:&nbsp;{{adom.adom}}</mat-option>
        }
      </mat-select>
      @if (!isLoading && availableAdoms.length === 0) {
        <mat-hint>You do not have permission to provision into any system.</mat-hint>
      }
    </mat-form-field>
    @if (isSerialNumberValid) {
      <div style="margin-bottom: 10px;">
        Inferred Fortigate model: {{ inferredModelNumber }}
      </div>
    }
    <button mat-raised-button (click)="continue()" color="primary"
      [disabled]="!isStoreNumberValid || !isSerialNumberValid || !isAdomValid || searchDisabled">
      Continue
    </button>
  </div>

  @if (state !== StateEnum.input) {
    <div id="provision-flow" class="flow">
      <div class="title">Variable Mapping</div>

      @if (state === StateEnum.loadingFields) {
        <div class="interact">
          <div class="message">
            Getting LAN/WAN fields...
          </div>
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>
      }

      @if (state === StateEnum.review || state === StateEnum.provisioning) {
        <div class="lanWanForm">
          <form name="lanWanForm" (ngSubmit)="f.form.valid && provisionClicked()" #f="ngForm" novalidate>
            <h5>LAN</h5>
            <div class="lanwan-form-row">
              <label>BYOD Gateway IP</label>
              <input type="text" name="byodGatewayIp" class="form-control" [(ngModel)]="lanWanFieldsModel.byodGatewayIp" #byodGatewayIp="ngModel" [ngClass]="{ 'is-invalid': byodGatewayIp.invalid }" [disabled]="state === StateEnum.provisioning" required [pattern]="ipAddressPattern">
            </div>
            <div class="lanwan-form-row">
              <label>PC IP</label>
              <input type="text" name="pcIp" class="form-control" [(ngModel)]="lanWanFieldsModel.pcIp" #pcIp="ngModel" [ngClass]="{ 'is-invalid': pcIp.invalid }" [disabled]="state === StateEnum.provisioning" required [pattern]="ipAddressPattern">
            </div>
            <div class="lanwan-form-row">
              <label>POS Gateway IP</label>
              <input type="text" name="posGatewayIp" class="form-control" [(ngModel)]="lanWanFieldsModel.posGatewayIp" #posGatewayIp="ngModel" [ngClass]="{ 'is-invalid': posGatewayIp.invalid }" [disabled]="state === StateEnum.provisioning" required [pattern]="ipAddressPattern">
            </div>
            <h5>WAN</h5>
            <div class="lanwan-form-row">
              <label>Type</label>
              <select name="wanType" class="form-control" [(ngModel)]="lanWanFieldsModel.wanType" #wanType="ngModel" [ngClass]="{ 'is-invalid': wanType.invalid }" [disabled]="state === StateEnum.provisioning" required>
                <option value="DHCP">DHCP</option>
                <option value="STATIC">STATIC</option>
              </select>
            </div>
            @if (f.form.get('wanType')?.value === 'STATIC') {
              <div class="lanwan-form-row">
                <label>Bandwidth</label>
                <select name="bandwidth" class="form-control" [(ngModel)]="lanWanFieldsModel.bandwidth" #bandwidth="ngModel" [ngClass]="{ 'is-invalid': bandwidth.invalid }" [disabled]="state === StateEnum.provisioning" required>
                  <option value="-1">N/A</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
              <div class="lanwan-form-row">
                <label>SpeedDuplex</label>
                <select name="speedDuplex" class="form-control" [(ngModel)]="lanWanFieldsModel.speedDuplex" #speedDuplex="ngModel" [ngClass]="{ 'is-invalid': speedDuplex.invalid }" [disabled]="state === StateEnum.provisioning" required>
                  <option value="auto">auto</option>
                  <option value="100full">100full</option>
                </select>
              </div>
              <div class="lanwan-form-row">
                <label>Gateway IP</label>
                <input type="text" name="gatewayIp" class="form-control" [(ngModel)]="lanWanFieldsModel.gatewayIp" #gatewayIp="ngModel" [ngClass]="{ 'is-invalid': gatewayIp.invalid }" [disabled]="state === StateEnum.provisioning" required [pattern]="ipAddressPattern">
              </div>
              <div class="lanwan-form-row">
                <label>IP</label>
                <input type="text" name="ip" class="form-control" [(ngModel)]="lanWanFieldsModel.ip" #ip="ngModel" [ngClass]="{ 'is-invalid': ip.invalid }" [disabled]="state === StateEnum.provisioning" required [pattern]="ipAddressPattern">
              </div>
              <div class="lanwan-form-row">
                <label>Subnet Mask</label>
                <input type="text" name="subnetMask" class="form-control" [(ngModel)]="lanWanFieldsModel.subnetMask" #subnetMask="ngModel" [ngClass]="{ 'is-invalid': subnetMask.invalid }" [disabled]="state === StateEnum.provisioning" required [pattern]="ipAddressPattern">
              </div>
            }
            @if (state === StateEnum.review) {
              <div class="interact">
                <div class="message">
                  If these values are correct, click Provision.
                </div>
                <button mat-raised-button color="primary" [disabled]="!f.valid">
                  Provision
                </button>
              </div>
            }
          </form>
        </div>
      }

      @if (state === StateEnum.provisioning) {
        <div class="interact">
          <div class="message">
            Provisioning device end to end (this can take a few minutes)...
          </div>
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>
      }

      @if (state === StateEnum.finished) {
        <div class="interact">
          <div class="message">
            Provisioning complete for store&nbsp;&nbsp;<strong>{{storeNumberInput}}</strong>&nbsp;&nbsp;<mat-icon class="checkmark">check_circle</mat-icon>
          </div>
        </div>
      }
    </div>
  }

</div>
